import Component from '../lib/Component'
import Flickity from 'flickity'

export default class Slideshow extends Component {
  constructor(elem, APP) {
    super(elem, APP)
    this.imgSliderElem = this.elem.querySelector('.js-PageSlider__images')
    this.slideCount = [...this.elem.querySelectorAll('.js-PageSlider__images .page-slider__slide')].length
    this.textSliderElem = this.elem.querySelector('.js-PageSlider__text')
    this.nextBtn = this.elem.querySelector('.js-PageSlider__next')
    this.prevBtn = this.elem.querySelector('.js-PageSlider__prev')

    this.hasControls = this.nextBtn && this.prevBtn
    this.autoplay = this.elem.hasAttribute('data-autoplay') ?
      parseInt(this.elem.getAttribute('data-autoplay')) :
      false
  }

  initSlider() {
    this.imgSlider = new Flickity(this.imgSliderElem, {
      contain: true,
      setGallerySize: false,
      prevNextButtons: false,
      pageDots: false,
      draggable: false,
      wrapAround: true,
      imagesLoaded: true,
      autoPlay: this.autoplay,
      pauseAutoPlayOnHover: !this.autoplay
    })

    this.textSlider = new Flickity(this.textSliderElem, {
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      draggable: false,
      wrapAround: true,
      autoPlay: this.autoplay,
      pauseAutoPlayOnHover: !this.autoplay
    })

    // some flex + flickity bug we need to set this after load
    setTimeout(() => {
      let slider = this.elem.querySelector('.js-PageSlider__images')
      slider.style.position = 'absolute'
      slider.style.height = '100%'
      slider.style.width = '100%'
    }, 0)
  }

  nextSlide() {
    this.textSlider.next()
    this.imgSlider.next()
  }

  prevSlide() {
    this.textSlider.previous()
    this.imgSlider.previous()
  }

  initSliderButtons() {
    this.nextBtn.addEventListener('click', () => this.nextSlide())
    this.prevBtn.addEventListener('click', () => this.prevSlide())
  }

  initCount() {
    this.elem.querySelector('.js-count').textContent = this.slideCount
    let current = this.elem.querySelector('.js-current')
    current.textContent = '1';
    this.imgSlider.on('select', () => {
      current.textContent = (this.imgSlider.selectedIndex + 1).toString()
    })
  }

  init() {
    this.initSlider()
    this.initCount()
    if (this.hasControls) {
      this.initSliderButtons()
    }
  }
}
